import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { selector: String }

  toggle() {
    const target = document.querySelector(this.selectorValue)
    if (target) target.classList.toggle("hidden")
  }
}
